export const TAG_BAN_CHAY = '/icons/tag/ban_chay.svg';
export const TAG_HOA_DON_NHANH = '/icons/tag/hoa_don_nhanh.svg';

// Đổi icon tag hàng điểm -> chị Ngọc Tạ nhờ 11Jun2022
export const TAG_HANG_DIEM = '/icons/tag/tag_hang_diem.svg';
// export const ICON_VERIFIED = '/icons/tag/verified.svg';
export const ICON_TAG_CAN_DATE = '/icons/tag/can_date.svg';
export const ICON_TAG_DOI_MAU = '/icons/tag/doi_mau.svg';
export const ICON_TAG_DONG_Y = '/icons/tag/dong_y.svg';
export const ICON_TAG_GAM_HANG_LANH = '/icons/tag/gam_hang_lanh.svg';
export const ICON_TAG_GIAO_NHANH = '/icons/tag/giao_nhanh.svg';
export const ICON_TAG_QUA_TANG = '/icons/tag/qua_tang.svg';
export const ICON_TAG_SUC_KHOE_HAU_COVID = '/icons/tag/suc_khoe_hau_covid.svg';
export const ICON_TAG_THIET_BI_CAO_CAP = '/icons/tag/thiet_bi_cao_cap.svg';
